export default "__VITE_ASSET__hD4rcgwA__"